import { React, Fragment, useState, useRef, useEffect } from "react";
import "./Files.scss";
import "../Tags/Tags.scss";
import axios from "axios";
import "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNoteSticky, faTrash, faFolder, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import * as fontIcons from "@fortawesome/free-solid-svg-icons";
import { Menu, Dialog, Transition } from "@headlessui/react";
import ThreeDots from "../../assets/icons/threeDots.svg";
import DeleteIcon from "../../assets/icons/DarkGrey-Delete.svg";
import LightDelete from "../../assets/icons/Grey_Delete.svg";
import ListView from "../../assets/icons/listView.svg";
import { toastify } from "../../components/Toast";
import { ToastContainer } from "react-toastify";
import compactCardIcon from "../../assets/icons/gridcard.svg";












import UploadIcon from "../../assets/icons/uploadIcon.svg";
import Closeicon from "../../assets/icons/close-icon.svg";
import Filesicon from "../../assets/icons/File icon.svg";
import ListviewIcon from "../../assets/icons/listBlackIcon.svg";
import GridviewIcon from "../../assets/icons/gridgreyIcon.svg";
import DismissButton from "../../assets/icons/dismissButton.svg";
import { useParams } from "react-router-dom";
import SortMbl from "../../assets/icons/sortmbl.svg";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";
import { useNavigate } from "react-router-dom";
import ShareCard from "../../shades/cards/shareCard";
// import axios from "axios";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import BlackDismiss from "../../assets/icons/dismissButton.svg";
import "react-select";



import DrawerFileCard from "./DrawerFileCard";
import DrawerTagFilter from "../DrawerTagFilter/DrawerTagFilter";
import Arrow from "../../assets/icons/arrow.svg";
import MoveModal from "../../shades/cards/includes/MoveModal";

function FilesPopup({ bucketName }) {
  const [isListView, setIsListView] = useState(true);
  const [isGridView, setIsGridView] = useState(true);
  const [isListViewIcon, setIsListViewIcon] = useState(false);
  const [isGridViewIcon, setIsGridViewIcon] = useState(false);
  const [isListViewOpen, setIsListViewOpen] = useState(false);
  const [, setIsGridViewOpen] = useState(true);
  const [filepopup, setFilePopup] = useState(false);
  const [notes, setNotes] = useState("");
  useState("");
  const [files, setFiles] = useState([]);
  const [filesData, setFilesData] = useState([]);
  const fileInputRef = useRef(null);
  const [buckets, setBuckets] = useState([]);
  const [isEditorFocused, setIsEditorFocused] = useState(false);
  let [isOpens, setIsOpen] = useState(false);
  const [, setSelectedBucket] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [fileUpdate, setFileUpdate] = useState(false);
  const [isTagOpen, setIsTagOpen] = useState(false);
  useState(false);
  const [tags, setTags] = useState([]);
  const [, setSelectedOption] = useState("");
  const [tagOptions, setTagOptions] = useState([]);
  const [, setInputValue] = useState("");
  useState("");
  const [, setSearchBucket] = useState("");
  const [FileRefresh, setFileRefresh] = useState(false);
  const [, setHoveredOption] = useState(null);
  useState(null);
  useState(false);
  const [filterTag, setFiltertag] = useState("");
  const [filterTagId, setFilterTagId] = useState("");
  const [inputValueSet, setInputValueSet] = useState("");
  const [FileSharePopup, setFileSharePopup] = useState(false);
  const [ShareFileId, setShareFileId] = useState("");
  const [appTheme, setAppTheme] = useState("");
  const [moveModal, setMoveModal] = useState(false);
  const [openMove, setOpenMove] = useState(false);
  const navigate = useNavigate();
  const bucketId = useParams();
  let cardFilterv = "";
  if (!localStorage.getItem("cardFilter")) {
    localStorage.setItem("cardFilter", "Created_Date");
    cardFilterv = "Created_Date";
  } else {
    cardFilterv = localStorage.getItem("cardFilter");
  }
  const [cardFilterDefault, setCardFilterDefault] = useState(cardFilterv);
  const fileNav = [
    { icon: faNoteSticky, name: "Select All",  },
    { icon: faTrash, name: "Unselect All",  },
  ];
  useEffect(() => {
    const handleStorageChange = () => {
      const theme = localStorage.getItem("theme");
      setAppTheme(theme);
    };

    window.addEventListener("storage", handleStorageChange);

    // Force a re-render when localStorage changes
    setAppTheme(localStorage.getItem("theme"));

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  useEffect(() => {
    // Function to fetch data from the API and update the state
    const token = localStorage.getItem("token");
    const fetchBuckets = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}buckets/user-buckets`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        ); // Replace this with the actual API endpoint
        setBuckets(response?.data?.data?.bucketList); // Assuming the API response is an array of bucket objects
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (token) {
      fetchBuckets();
    }
  }, []);
  const fetchTags = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API}tags/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );
      setTagOptions(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);
  const updateFiles = () => {
    setFileUpdate(!fileUpdate);
  };
  useState("");
  useState([]);
  useState(0);
  useState("");
  useEffect(() => {
    // Refetch for this route/refresh only; discard the previous request on cleanup.
    const controller = new AbortController();
    let active = true;

    // api url

    const token = localStorage.getItem("token");

    axios
      .post(
        `
      ${process.env.REACT_APP_API}cards/cardList-by-bucketId`,
        {
          filterValue: cardFilterDefault,
          limit: 10000,
          bucketId: `${bucketId.id}`,
          type: "File",
          tagId: filterTagId ? filterTagId : "",
        },
        { signal: controller.signal,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(function (response) {
        if (!active) return;
        setIsLoading(false);
        setFilesData(response?.data?.data?.cardsList);
        setFileRefresh(false);
        // setCardList(response.data.data);
      })
      .catch(function (error) {
        if (!active) return;
        console.error(error);
      });

    return () => { active = false; controller.abort(); };
  }, [cardFilterDefault, fileUpdate, FileRefresh, filterTagId, bucketId.id]);
  useEffect(() => {
    setTimeout(() => {
    }, 5000);
  }, [filesData]);

  const MoveCard = async () => {
    setMoveModal(true)
    setOpenMove(true);
  };
  const closeMove = () => {
    // setIsBucketOpen(false);
    // setSelectedItems("")
    setSelectedItems([])
    setMoveModal(false)
    setOpenMove(false);
    // setselectedBucketId("");
    // setSearchBucket("");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const newFiles = Array.from(event.dataTransfer.files);
    const currentFiles = files.length; // Current number of files in state
    const totalSize = newFiles.reduce((acc, file) => acc + file.size, 0);

    // Validate the total number of files
    if (currentFiles + newFiles.length > 3) {
      toastify("error", "Please select up to 3 files.");
      return;
    }

    // Validate the size of each file
    for (const file of newFiles) {
      if (newFiles.length === 1 && file.size > 10 * 1024 * 1024) {
        // 10 MB limit
        toastify("error", "File size should be less than 10 MB.");
        return;
      }
    }

    // Validate total size for 2-3 files
    if (newFiles.length > 1 && totalSize > 30 * 1024 * 1024) {
      // 30 MB limit
      toastify("error", "Selected files should be less than 30 MB.");
      return;
    }

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };
  const cardsRefresh = () => {
    setFileRefresh(!FileRefresh);
  };
  const handleSelectClick = (text) => {
    if (text === "Select All") {
      setSelectedItems(filesData.map((file) => file._id));
    } else if (text === "Unselect All") {
      setSelectedItems([]);
    }
  };

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((item) => item !== value)
      );
    }
  };
  const handleTagsChange = (newTags) => {
    setTags(newTags);
    const inputElement = document.querySelector(".react-tagsinput-input");

    // Check if the input element exists before calling focus
    if (inputElement) {
      inputElement.focus();
    }
  };

  const handleStarClick = async (cardId, star) => {
    await updateCard(cardId, !star);
  };
  const updateCard = async (cardId, star) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API}cards/update`,
        { cardId: cardId, starred: star },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toastify("success", response.data.message);
      setFileRefresh(true);
    } catch (error) {
      console.error(error);
      toastify("error", error.response.data.message);
    }
  };
  const modules = {
    clipboard: {
      matchVisual: false,
    },
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ size: [] }],
      [{ font: [] }],
      [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [
        {
          color: [
            "#FF0000", // Red
            "#00FF00", // Green
            "#0000FF", // Blue
            "#FFFF00", // Yellow
            "#00FFFF", // Cyan
            "#FF00FF", // Magenta
            "#000000", // Black
            "#FFFFFF", // White
            "#808080", // Gray

            // Web-safe colors
            "#800000", // Maroon
            "#808000", // Olive
            "#000080", // Navy
            "#800080", // Purple
            "#008080", // Teal
            "#C0C0C0", // Silver
            // Shades of gray
            "#A9A9A9", // Dark gray
            "#696969", // Dim gray
            "#D3D3D3", // Light gray
            "#DCDCDC", // Gainsboro

            // Pastel colors
            "#FFB6C1", // Light pink
            "#90EE90", // Light green
            "#ADD8E6", // Light blue
            "#E6E6FA", // Lavender

            // CSS named colors
            "#FF6347", // Tomato
            "#F4A460", // Sandy Brown
            "#6495ED", // Cornflower Blue
            "#9932CC", // Dark Orchid
          ],
        },
      ],
      [
        {
          background: [
            "#FF0000", // Red
            "#00FF00", // Green
            "#0000FF", // Blue
            "#FFFF00", // Yellow
            "#00FFFF", // Cyan
            "#FF00FF", // Magenta
            "#000000", // Black
            "#FFFFFF", // White
            "#808080", // Gray

            // Web-safe colors
            "#800000", // Maroon
            "#808000", // Olive
            "#000080", // Navy
            "#800080", // Purple
            "#008080", // Teal
            "#C0C0C0", // Silver
            // Shades of gray
            "#A9A9A9", // Dark gray
            "#696969", // Dim gray
            "#D3D3D3", // Light gray
            "#DCDCDC", // Gainsboro

            // Pastel colors
            "#FFB6C1", // Light pink
            "#90EE90", // Light green
            "#ADD8E6", // Light blue
            "#E6E6FA", // Lavender

            // CSS named colors
            "#FF6347", // Tomato
            "#F4A460", // Sandy Brown
            "#6495ED", // Cornflower Blue
            "#9932CC", // Dark Orchid
          ],
        },
      ],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font",
  ];

  const handleEditorFocus = () => {
    setIsEditorFocused(true);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("my-class-selected");
    }
  };
  const handleClick = () => {
    setIsEditorFocused(true);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("my-class-selected");
    }
  };
  const handleEditorClick = () => {
    setIsEditorFocused(true);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("my-class-selected");
    }
  };
  const handlePaste = (event) => {
    event.preventDefault();
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedHTML = clipboardData.getData("text/html");
    const quill = this.reactQuillRef.getEditor();
    const selection = quill.getSelection();
    const index = selection ? selection.index : 0;
    const delta = quill.clipboard.convert(pastedHTML);
    quill.updateContents(delta, Quill.sources.USER);
    quill.setSelection(index + delta.length(), Quill.sources.SILENT);
  };
  const handleEditorBlur = () => {
    setIsEditorFocused(false);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove("my-class-selected");
    }
  };
  const handleKeyUp = () => {
    setIsEditorFocused(true);
    const elements = document.getElementsByClassName("ql-toolbar");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("my-class-selected");
    }
  };
  const handleFocus = (e) => {
    e.stopPropagation();
    setIsTagOpen(true);
  };
  const handleBlur = () => {
    setIsTagOpen(false);
  };

  const handleMouseEnter = (option) => {
    setHoveredOption(option);
  };

  const handleMouseLeave = () => {
    setHoveredOption(null);
  };



  tagOptions.map((item) => ({
    value: item._id,
    label: item.name,
  }));
  const filteredOptions = tagOptions.filter((option) =>
    option.name.toLowerCase().includes(inputValueSet.toLowerCase())
  );

  const handleSetInputValue = (e) => {
    setInputValueSet(e);
    setIsTagOpen(true);
  };


  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      const newTag = selectedOption.name;
      setTags([...tags, newTag]);
      setSelectedOption(null);
      setInputValue("");
      handleTagsChange([...tags, newTag]);
      handleBlur();
    }
  };




  const deleteCard = async () => {
    setIsOpen(true);
  };

  const handleDeleteCard = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API}cards/delete`,
        {
          data: { deletedIds: selectedItems },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toastify("success", response.data.message);
      setSelectedItems([]);
      CloseDeleteModal();
      updateFiles();
    } catch (error) {
      console.error(error);
      CloseDeleteModal();
      setIsLoading(false);
      toastify("error", error.response.data.message);
    }
  };
  const handleSubmit = async () => {
    const tagsPayload = JSON.stringify(tags.map((tag) => ({ name: tag })));
    const userData = JSON.parse(localStorage.getItem("userData"));
    const token = localStorage.getItem("token");
    setIsLoading(true);
    const formData = new FormData();
    formData.append("tags", tagsPayload);
    formData.append("note", notes ? notes : "");
    formData.append("userId", userData._id);
    formData.append("bucketId", bucketId.id);
    files.forEach((file, index) => {
      formData.append("myFiles", file);
    });

    await axios
      .post(`${process.env.REACT_APP_API}cards/upload-files`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        if ((response.data.statusCode === 201 || response.data.statusCode === "201")) {
          toastify("success", response.data.message);
          setFiles("");
          setSelectedBucket("");
          setNotes("");
          setIsLoading(false);
          updateFiles();
          closeFilePopup();

        }
      })
      .catch(function (error) {
        toastify("error", error.response.data.message);
      });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const handleAction = (item, url, type) => {
    if (item.name === "Download") {
      handleDownloadFile(url, type);
    }
  };
  const handleDownloadFile = (Url, type) => {
    // return
    const token = localStorage.getItem("token");
    if (Url) {
      setIsLoading(true);
      axios
        .post(
          `${process.env.REACT_APP_API}cards/download-file`,
          { fileUrl: Url },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          // You should read the response data as an array buffer
          const base64Data = response?.data?.data?.fileBase64;
          if (base64Data) {
            setIsLoading(false);
          }
          const byteCharacters = atob(base64Data);

          // Convert the data to an array of bytes
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Create a Blob from the byte array
          const blob = new Blob([byteArray], { type });

          // Create an Object URL for the Blob
          const url = URL.createObjectURL(blob);

          // Create an anchor element to trigger the download
          const a = document.createElement("a");
          a.href = url;
          a.download = `image.${type}`; // Set the desired filename and file extension
          a.style.display = "none";
          document.body.appendChild(a);

          // Simulate a click on the anchor to trigger the download
          a.click();

          // Clean up by revoking the Object URL
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    }
  };

  const handleRemoveFile = (indexToRemove) => {
    setFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(indexToRemove, 1);
      return updatedFiles;
    });
  };
  const handleProcedureContentChange = (content, delta, source, editor) => {
    setNotes(content);
  };

  // const handleAddNotes = (event) => {
  //   setNotes(event.target.value);
  // };
  const handleFileChange = (event) => {
    event.preventDefault();
    const newFiles = Array.from(event.target.files);
    const currentFiles = files.length; // Current number of files in state
    const totalSize = newFiles.reduce((acc, file) => acc + file.size, 0);

    // Validate the total number of files
    if (currentFiles + newFiles.length > 3) {
      toastify("error", "Please select up to 3 files.");
      return;
    }

    // Validate the size of each file
    for (const file of newFiles) {
      if (newFiles.length === 1 && file.size > 10 * 1024 * 1024) {
        // 10 MB limit
        toastify("error", "File size should be less than 10 MB.");
        return;
      }
    }

    // Validate total size for 2-3 files
    if (newFiles.length > 1 && totalSize > 30 * 1024 * 1024) {
      // 30 MB limit
      toastify("error", "Selected files should be less than 30 MB.");
      return;
    }

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleFilePopup = () => {
    setFilePopup(true);
  };
  const handleClickBrowse = () => {
    fileInputRef.current.value = null;
    fileInputRef.current.click();
  };
  function closeFilePopup() {
    setFilePopup(false);
    setTags([]);
    handleBlur();
    setSearchBucket("");
    setFiles([]);
    setNotes("");
  }
  let [isOpenss, setIsOpens] = useState(false);

  const handleIsListView = () => {
    setIsListView(false);
    setIsGridView(false);
    setIsListViewOpen(true);
    setIsGridViewOpen(false);
    setIsListViewIcon(true);
    setIsGridViewIcon(true);
  };

  const handleIsGridView = () => {
    setIsListView(true);
    setIsGridView(true);
    setIsGridViewOpen(true);
    setIsListViewOpen(false);
    setIsListViewIcon(false);
  };

  const handleIsListViewIcon = () => {
    setIsListView(true);
    setIsGridView(false);
    setIsListViewOpen(false);
    setIsGridViewOpen(true);
    setIsListViewIcon(false);
    // setIsGridViewIcon(true)
  };

  const handleIsGridViewIcon = () => {
    setIsListView(true);
    setIsGridView(true);
    setIsListViewOpen(false);
    setIsGridViewOpen(true);
    setIsListViewIcon(false);
    setIsGridViewIcon(false);
  };

  function closeCardModal() {
    // setSelectedItems([]);
    setIsOpens(false);
  }

  const CloseDeleteModal = () => {
    setIsOpen(false);
  };
  const bucketNav = [
    // { icon: faPencil, name: 'Edit Name', href: '#' },
    // { icon: faNoteSticky, name: 'Create New Card', href: '#' },
    // { icon: faTrash, name: 'Delete', href: '#' },
    // { icon: faFolder, name: 'Customize New Card', href: '#' },
    { icon: faFolder, name: "Download", href: "#" },
  ];

  const filterFilesDropDown = [
    { name: "Created Date", href: "#" },
    { name: "Recent Activity", href: "#" },
    { name: "Ascending Order", href: "#" },
    { name: "Descending Order", href: "#" },
  ];

  const [filtersText, setFiltersText] = useState(
    cardFilterv === "Created_Date"
      ? filterFilesDropDown[0].name
      : cardFilterv === "Descending_Order"
        ? filterFilesDropDown[3].name
        : cardFilterv === "Ascending_Order"
          ? filterFilesDropDown[2].name
          : cardFilterv === "Recent_Activity"
            ? filterFilesDropDown[1].name
            : ""
  );
  const handleFilterFilesText = (text) => {
    setFiltersText(text);
    setIsLoading(true);

    const filterValues =
      text === "Created Date"
        ? "Created_Date"
        : text === "Descending Order"
          ? "Descending_Order"
          : text === "Ascending Order"
            ? "Ascending_Order"
            : text === "Recent Activity"
              ? "Recent_Activity"
              : "";
    localStorage.setItem("cardFilter", filterValues);
    setCardFilterDefault(filterValues);
    const token = localStorage.getItem("token");

    axios
      .post(
        `${process.env.REACT_APP_API}cards/cardList-by-bucketId`,
        {
          filterValue: filterValues,
          bucketId: `${bucketId.id}`,
          type: "File",
          limit: 10000,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(function (response) {
        setIsLoading(false);
        setFilesData(response?.data?.data?.cardsList);
        // setCardList(response.data.data);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const handleSharePop = (id) => {
    setShareFileId(id);
    setFileSharePopup(true);
  };
  const closeSharePop = () => {
    setFileSharePopup(false);
  };
  // const handleFilterFilesText = (text) => {
  //   setFiltersSelectText(text);
  // }



  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <>
      {isLoading ? (
        <div className="App-loading">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : (
        <div className="files-wholesection">
          <ToastContainer />
          <div className="bucketHeader">
            <div className="grid grid-cols">
              <div className="bucketFeature col-span-2">
                <div className="flex items-center">
                  <h2 className="text-xl mybuckets-content dark:text-[#fff]">
                    Files
                  </h2>
                  <div className="subbucketheaderdesktop-section">
                    <button
                      style={{
                        filter:
                          "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                      }}
                      className="buttonpadding-content mx-8 text-[16px] rounded-full bg-[#FF6600] text-white pr-[32px]"
                      onClick={handleFilePopup}
                    >
                      <FontAwesomeIcon
                        className="pl-[23px] pr-[17.73px]"
                        icon={fontIcons.faPlus}
                      />
                      <span className="createbutton-context">New</span>
                    </button>
                  </div>
                  <div className="subbucketheadermbl-section">
                    <button
                      style={{
                        filter:
                          "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                      }}
                      className="buttonpadding-content mx-2 text-[16px] rounded-full bg-[#FF6600] text-white pr-[32px]"
                      onClick={handleFilePopup}
                    >
                      <FontAwesomeIcon
                        className="pl-[23px] pr-[17.73px]"
                        icon={fontIcons.faPlus}
                      />
                      <span className="createbutton-context">New</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          {FileSharePopup && (
            <div
              className="filesuploadpopup relative !z-[999]"
              style={{ height: "100%" }}
              onClick={closeSharePop}
            >
              <div
                className="subinviteupload-section"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="teaminvitesection flex">
                  <div className="teammembers-content">Share</div>
                  <div
                    className="dismissSubfiles-content"
                    onClick={closeSharePop}
                  >
                    <img src={BlackDismiss} alt="dismissButton" />
                  </div>
                </div>
                <ShareCard
                  shareBucketId={ShareFileId}
                  closeSharePop={closeSharePop}
                  cardsRefresh={cardsRefresh}
                />
              </div>
            </div>
          )}
          {filepopup && (
            <div
              className="filesuploadpopup relative !z-[999]"
              style={{ height: "100%" }}
              onClick={closeFilePopup}
            >
              <div
                className="subfilesupload-section"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsTagOpen(false);
                }}
              >
                <div className="fileupload-section flex">
                  <div className="fileupload-content">File Upload</div>
                  <div
                    className="dismissSubfiles-content"
                    onClick={closeFilePopup}
                  >
                    <img src={DismissButton} alt="dismissButton" />
                  </div>
                </div>
                <hr />
                <div className="uploadtext-content">
                  Upload files for secure storage
                </div>
                <div className="flex  items-center rounded-3xl border-0 menusubbucketitems-popupcontent">
                  <div className="w-full">
                    <strong className="createdsubtext-content pr-4">
                      <div className="flex fliesbucket-inputcontent">
                        <input
                          type="text"
                          placeholder="Select a bucket"
                          className="filespopupbg-content"
                          value={bucketName}
                          readOnly
                        />
                      </div>
                    </strong>
                  </div>

                  {/* <div><FontAwesomeIcon className="iconimg-content" style={{ fontSize: '12px', color: '#707070' }} icon={faChevronDown} /></div> */}
                </div>
                <div className="pos-tagsdropdown">
                  <div
                    className="flex items-center rounded-3xl border-0 menusubitems-content"
                    onClick={handleFocus}
                  >
                    <div className="w-full">
                      <div className="flex files-tags">
                        <TagsInput
                          value={tags}
                          onChange={handleTagsChange}
                          inputValue={inputValueSet}
                          onChangeInput={(e) => handleSetInputValue(e)}
                        />
                        <FontAwesomeIcon
                          className="fileicon-content"
                          style={{}}
                          icon={faChevronDown}
                          onClick={handleFocus}
                        />
                      </div>

                      {/* <button onClick={handleAddFromDropdown}>Add Tag from Dropdown</button> */}
                    </div>
                  </div>
                  {isTagOpen && (
                    <div className="pos-dropdown">
                      <nav>
                        <div className="tab-scrolls tagscard">
                          <ul className="dropdown">
                            {filteredOptions.map((option) => (
                              <li
                                key={option._id}
                                onMouseEnter={() => handleMouseEnter(option)}
                                onMouseLeave={handleMouseLeave}
                              >
                                <p onClick={() => handleSelectChange(option)}>
                                  {option.name}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </nav>
                    </div>
                  )}
                </div>
                <div
                  className="border bg-[#f5f5f5] border-[#e5e5e5] dark:border-[#e5e5e5] border-1 rounded-md overflow-hidden"
                  onClick={handleClick}
                  style={{
                    resize: "horizontal",
                    height: "200px",
                    marginBottom: "24px",
                  }}
                >
                  {(isEditorFocused === false && !notes) ||
                    (isEditorFocused === false && notes === "<p><br></p>") ? (
                    <div
                      className="addnote-text"
                      style={{ paddingLeft: "14px", marginTop: "10px" }}
                    >
                      <p>Add Notes</p>
                    </div>
                  ) : (
                    ""
                  )}
                  <ReactQuill
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    value={notes}
                    onChange={handleProcedureContentChange}
                    onFocus={handleEditorFocus}
                    onClick={handleEditorClick}
                    onBlur={handleEditorBlur}
                    onKeyUp={handleKeyUp}
                    onPaste={handlePaste}
                  />
                  {isEditorFocused && (
                    <div
                      className="backgroundcard-rightcontent bg-[#F7F7F7] px-3 py-4 flex items-center"
                      onClick={handleClick}
                    >
                      {notes}
                    </div>
                  )}

                  {/* <input
        type="text"
        className="createdsubtext-content pr-4"
        value={notes}
        onChange={handleAddNotes} 
      /> */}
                </div>
                <div
                  className="browser-content"
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                >
                  <div>
                    <span
                      className="browse-content"
                      onClick={handleClickBrowse}
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        ref={fileInputRef}
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        onClick={(e) => (e.target.value = null)}
                        style={{ display: "none" }}
                      />
                      <img
                        className="uploadimg-content"
                        src={UploadIcon}
                        alt="UploadIcon"
                      />
                    </span>
                  </div>
                  <div className="drag-content">
                    Drag & Drop, or{" "}
                    <span
                      className="browse-content"
                      onClick={handleClickBrowse}
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        ref={fileInputRef}
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        onClick={(e) => (e.target.value = null)}
                        style={{ display: "none" }}
                      />
                      Browse
                    </span>{" "}
                    your files
                  </div>

                  {/* {files.length > 0 && (
                    <span className="mx-5 my-1 ">
                      {files.length} files selected
                    </span>
                  )} */}
                </div>
                {files &&
                  files.map((file, index) => {
                    return (
                      <div
                        className="mt-[30px] files-selected flex"
                        key={index}
                      >
                        <img
                          className="mr-[8px]"
                          src={Filesicon}
                          alt="UploadIcon"
                        />
                        <p className="uploadfile-name">{file?.name}</p>
                        <img
                          className="justify-end ml-[auto]"
                          src={Closeicon}
                          alt="UploadIcon"
                          onClick={() => handleRemoveFile(index)}
                        />
                      </div>
                    );
                  })}
                <div className="flex justify-end lastfile-section">
                  <div
                    className="cancel-content"
                    onClick={closeFilePopup}
                    style={{ cursor: "pointer" }}
                  >
                    Cancel
                  </div>
                  <button
                    style={{
                      filter: "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                    }}
                    className="buttonpadding-content text-[16px] rounded-full bg-[#FF6600] text-white"
                    onClick={handleSubmit}
                  >
                    <span className="savebutton-context">Upload</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="subbucketheaderdesktop-section">
            <div className="cards-filter  mt-[18px] flex justify-between">
              <div className="flex items-center">
                <div className="card-count flex items-center">
                  <h4 className="cardssubBuckets-content">Files</h4>
                  <span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">
                    {filesData?.length}
                  </span>
                </div>
                <Menu as="div" className="relative px-2">
                  <Menu.Button className="relative ml-3 inline-flex items-center px-1 py-2 text-sm font-semibold text-gray-900 ">
                    {/* <FontAwesomeIcon className="text-lg text-[#707070]" icon={faEllipsisVertical} /> */}
                    <img
                      className="threedots-content"
                      src={ThreeDots}
                      alt="threeDots"
                    />
                  </Menu.Button>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute left-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {fileNav.map((item) => (
                        <Menu.Item key={item.name}>
                          {({ active }) => (
                            <button type="button" data-former-link=""

                              className={classNames(
                                active ? "bg-gray-100" : "",
                                "block py-2 px-4 text-sm text-gray-700"
                              )}
                              onClick={() => {
                                handleSelectClick(item.name);
                              }}
                            >
                              <span className="pr-2">
                                <FontAwesomeIcon
                                  className="text-[#797979]"
                                  icon={item.icon}
                                />
                              </span>
                              <span className="text-black">{item.name}</span>
                            </button>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Transition>
                </Menu>
                {selectedItems.length > 0 ? (
                  <img
                    src={appTheme === "light" ? DeleteIcon : LightDelete}
                    alt="deleteIcon"
                    className="px-3"
                    onClick={() => deleteCard()}
                  />
                ) : (
                  <img
                    src={appTheme === "light" ? LightDelete : DeleteIcon}
                    alt="deleteIcon"
                    className="px-3"
                  // onClick={() => deleteCard()}
                  />
                )}
                <Transition appear show={isOpens} as={Fragment}>
                  <Dialog
                    as="div"
                    className="relative z-[9999]"
                    onClose={CloseDeleteModal}
                  >
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                      <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0 scale-95"
                          enterTo="opacity-100 scale-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100 scale-100"
                          leaveTo="opacity-0 scale-95"
                        >
                          <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                            <Dialog.Title
                              as="h3"
                              className="text-lg font-medium leading-6 text-gray-900"
                            >
                              Delete
                            </Dialog.Title>
                            <div className="mt-2">
                              <p className="text-sm text-gray-500">
                                Are you sure you want to delete?
                              </p>
                            </div>

                            <div className="mt-4">
                              <button
                                style={{
                                  background: "#FF6600",
                                  width: "80px",
                                  color: "#fff",
                                  padding: "10px",
                                  borderRadius: "50px",
                                }}
                                type="button"
                                className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                onClick={() => handleDeleteCard()}
                              >
                                Yes
                              </button>
                              <button
                                style={{
                                  background: "#000",
                                  width: "80px",
                                  color: "#fff",
                                  padding: "10px",
                                  borderRadius: "50px",
                                }}
                                type="button"
                                className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                onClick={CloseDeleteModal}
                              >
                                No
                              </button>
                            </div>
                          </Dialog.Panel>
                        </Transition.Child>
                      </div>
                    </div>
                  </Dialog>
                </Transition>
                <img src={Arrow} alt="arrow" className="px-3" onClick={MoveCard} />
                {/* <img src={DeleteIcon} alt="deleteIcon" className="px-3" /> */}

                {/* <Menu as="div" className="relative flex-shrink-0">
              <div>
                <Menu.Button className="flex rounded-full focus:outline-none bordered">
                  <div href="#" className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500 bucketswhole-spacecontent">
                    <strong className="createdbuckettext-content pr-4">Tags</strong>
                    <FontAwesomeIcon className="dropdownicon-bucketcontent" style={{fontSize:'12px'}} icon={faChevronDown} />
                  </div>
                </Menu.Button>
              </div> 
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">                           
                  {filterBucketsDropDown.map((item) => (
                    <Menu.Item key={item.name}>
                      {({ active }) => (
                        <a
                          onClick={()=>{handleFilterTagText(item.name)}}
                          href={item.href}
                          className={classNames(
                            active ? 'bg-gray-100' : '',
                            'block py-2 px-4 text-[13px] text-gray-700'
                          )}
                        >
                          {item.name}
                        </a>
                      )}
                    </Menu.Item>
                  ))}
                </Menu.Items>
              </Transition>
          </Menu> */}
                <DrawerTagFilter
                  options={tagOptions}
                  selectedId={filterTagId}
                  selectedName={filterTag}
                  onSelect={(option) => { setFiltertag(option.name); setFilterTagId(option._id); }}
                  onClear={() => { setFiltertag(""); setFilterTagId(""); }}
                />
                <Transition appear show={isOpenss} as={Fragment}>
                  <Dialog
                    as="div"
                    className="relative z-[9999]"
                    onClose={closeCardModal}
                  >
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                      <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0 scale-95"
                          enterTo="opacity-100 scale-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100 scale-100"
                          leaveTo="opacity-0 scale-95"
                        >
                          <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                            <Dialog.Title
                              as="h3"
                              className="text-lg font-medium leading-6 text-gray-900"
                            >
                              Delete
                            </Dialog.Title>
                            <div className="mt-2">
                              <p className="text-sm text-gray-500">
                                Are you sure you want to delete?
                              </p>
                            </div>

                            <div className="mt-4">
                              <button
                                style={{
                                  background: "#FF6600",
                                  width: "80px",
                                  color: "#fff",
                                  padding: "10px",
                                  borderRadius: "50px",
                                }}
                                type="button"
                                className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                              >
                                Yes
                              </button>
                              <button
                                style={{
                                  background: "#000",
                                  width: "80px",
                                  color: "#fff",
                                  padding: "10px",
                                  borderRadius: "50px",
                                }}
                                type="button"
                                className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                onClick={closeCardModal}
                              >
                                No
                              </button>
                            </div>
                          </Dialog.Panel>
                        </Transition.Child>
                      </div>
                    </div>
                  </Dialog>
                </Transition>
              </div>
              <div className="flex">
                <div className="flex items-center justify-end">
                  <div className="filter display-content">
                    {isListView && (
                      <div onClick={handleIsListView}>
                        <button type="button" data-former-link="" className="viewGrid" >
                          <img
                            className="mt-1 listcard-imgcontent"
                            src={ListView}
                            style={{ color: "#000000" }}
                            alt="listView"
                          />
                        </button>
                      </div>
                    )}
                    {isListViewIcon && (
                      <div onClick={handleIsListViewIcon}>
                        <button type="button" data-former-link="" className="viewGrid" >
                          <img
                            className="mt-1 listcard-imgcontent"
                            src={ListviewIcon}
                            alt="listviewIcon "
                          />
                        </button>
                      </div>
                    )}
                    {isGridView && (
                      <div onClick={handleIsGridView}>
                        <button type="button" data-former-link="" className="viewGrid" >
                          <img
                            className="mt-1 compact-imgcontent"
                            src={compactCardIcon}
                            alt="compactIcon"
                          />
                        </button>
                      </div>
                    )}
                    {isGridViewIcon && (
                      <div onClick={handleIsGridViewIcon}>
                        <button type="button" data-former-link="" className="viewGrid" >
                          <img
                            className="mt-1 compact-imgcontent"
                            src={GridviewIcon}
                            alt="compactIcon"
                          />
                        </button>
                      </div>
                    )}
                  </div>

                  <span className="sorttext-content mx-3 dark:text-[#acacac]">
                    Sort By
                  </span>
                  <Menu as="div" className="relative flex-shrink-0">
                    <div>
                      <Menu.Button className="flex rounded-full focus:outline-none ">
                        <span data-former-link=""

                          className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                        >
                          <strong className="createdtext-content pr-4">
                            {filtersText}
                          </strong>
                          <FontAwesomeIcon
                            style={{ fontSize: "12px", color: "#707070" }}
                            icon={faChevronDown}
                          />
                        </span>
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        {filterFilesDropDown.map((item) => (
                          <Menu.Item key={item.name}>
                            {({ active }) => (
                              <button type="button" data-former-link=""
                                onClick={() => {
                                  handleFilterFilesText(item.name);
                                }}

                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block py-2 px-4 text-sm text-gray-700"
                                )}
                              >
                                {item.name}
                              </button>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              </div>
            </div>
          </div>

          <div className="subbucketheadermbl-section ">
            <div className="cards-filter  mt-[18px] ml-[10px] mr-[10px] flex justify-between">
              <div className="flex items-center">
                <div className="card-count flex items-center">
                  <h4 className="cardssubBuckets-content">Files</h4>
                  <span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">
                    {filesData?.length}
                  </span>
                </div>
                <Menu as="div" className="relative px-2">
                  <Menu.Button className="relative ml-3 inline-flex items-center px-1 py-2 text-sm font-semibold text-gray-900 ">
                    {/* <FontAwesomeIcon className="text-lg text-[#707070]" icon={faEllipsisVertical} /> */}
                    <img
                      className="threedots-content"
                      src={ThreeDots}
                      alt="threeDots"
                    />
                  </Menu.Button>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {fileNav.map((item) => (
                        <Menu.Item key={item.name}>
                          {({ active }) => (
                            <button type="button" data-former-link=""

                              onClick={() => handleSelectClick(item.name)}
                              className={classNames(
                                active ? "bg-gray-100" : "",
                                "block py-2 px-4 text-sm text-gray-700"
                              )}
                            >
                              <span className="pr-2">
                                <FontAwesomeIcon
                                  className="text-[#797979]"
                                  icon={item.icon}
                                />
                              </span>
                              <span className="text-black">{item.name}</span>
                            </button>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Transition>
                </Menu>
                <img
                  src={DeleteIcon}
                  alt="deleteIcon"
                  className="px-3"
                  onClick={() => deleteCard()}
                />
                <Transition appear show={isOpens} as={Fragment}>
                  <Dialog
                    as="div"
                    className="relative z-[9999]"
                    onClose={CloseDeleteModal}
                  >
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                      <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0 scale-95"
                          enterTo="opacity-100 scale-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100 scale-100"
                          leaveTo="opacity-0 scale-95"
                        >
                          <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                            <Dialog.Title
                              as="h3"
                              className="text-lg font-medium leading-6 text-gray-900"
                            >
                              Delete
                            </Dialog.Title>
                            <div className="mt-2">
                              <p className="text-sm text-gray-500">
                                Are you sure you want to delete?
                              </p>
                            </div>

                            <div className="mt-4">
                              <button
                                style={{
                                  background: "#FF6600",
                                  width: "80px",
                                  color: "#fff",
                                  padding: "10px",
                                  borderRadius: "50px",
                                }}
                                type="button"
                                className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                onClick={() => handleDeleteCard()}
                              >
                                Yes
                              </button>
                              <button
                                style={{
                                  background: "#000",
                                  width: "80px",
                                  color: "#fff",
                                  padding: "10px",
                                  borderRadius: "50px",
                                }}
                                type="button"
                                className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                onClick={CloseDeleteModal}
                              >
                                No
                              </button>
                            </div>
                          </Dialog.Panel>
                        </Transition.Child>
                      </div>
                    </div>
                  </Dialog>
                </Transition>
                {/* <img src={DeleteIcon} alt="deleteIcon" className="px-3" /> */}

                <Transition appear show={isOpenss} as={Fragment}>
                  <Dialog
                    as="div"
                    className="relative z-[9999]"
                    onClose={closeCardModal}
                  >
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                      <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0 scale-95"
                          enterTo="opacity-100 scale-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100 scale-100"
                          leaveTo="opacity-0 scale-95"
                        >
                          <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                            <Dialog.Title
                              as="h3"
                              className="text-lg font-medium leading-6 text-gray-900"
                            >
                              Delete
                            </Dialog.Title>
                            <div className="mt-2">
                              <p className="text-sm text-gray-500">
                                Are you sure you want to delete?
                              </p>
                            </div>

                            <div className="mt-4">
                              <button
                                style={{
                                  background: "#FF6600",
                                  width: "80px",
                                  color: "#fff",
                                  padding: "10px",
                                  borderRadius: "50px",
                                }}
                                type="button"
                                className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                              >
                                Yes
                              </button>
                              <button
                                style={{
                                  background: "#000",
                                  width: "80px",
                                  color: "#fff",
                                  padding: "10px",
                                  borderRadius: "50px",
                                }}
                                type="button"
                                className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                onClick={closeCardModal}
                              >
                                No
                              </button>
                            </div>
                          </Dialog.Panel>
                        </Transition.Child>
                      </div>
                    </div>
                  </Dialog>
                </Transition>
                {/* <FontAwesomeIcon className="transform rotate-45 px-3" icon={faArrowUp } /> */}
              </div>
              <div className="flex">
                <div className="flex items-center justify-end">
                  <div className="filter display-content"></div>

                  <div>
                    <Menu
                      as="div"
                      className="sortmbl-content relative flex-shrink-0"
                    >
                      <div>
                        <Menu.Button className="flex rounded-full dark:text-[#acacac] focus:outline-none">
                          <span data-former-link=""

                            className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500 "
                          >
                            <img src={SortMbl} alt="SortMbl" />
                          </span>
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="filter-dropdown dropdownmbl-content absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {filterFilesDropDown.map((item) => (
                            <Menu.Item key={item.name}>
                              {({ active }) => (
                                <button type="button" data-former-link=""
                                  onClick={() => {
                                    handleFilterFilesText(item.name);
                                  }}

                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block py-2 px-4 text-sm text-gray-700"
                                  )}
                                >
                                  {item.name}
                                </button>
                              )}
                            </Menu.Item>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bucket-drawer-mobile-tags">
            <DrawerTagFilter
              options={tagOptions}
              selectedId={filterTagId}
              selectedName={filterTag}
              onSelect={(option) => { setFiltertag(option.name); setFilterTagId(option._id); }}
              onClear={() => { setFiltertag(""); setFilterTagId(""); }}
            />
          </div>

          <div className={`files-page bucket-drawer-file-grid ${isListViewOpen ? "bucket-drawer-file-grid--list" : ""}`}>
            {filesData.length > 0 ? (
              <div className="files-grid">
                {filesData.map((file) => (
                  <DrawerFileCard
                    key={file._id}
                    file={file}
                    selected={selectedItems.includes(file._id)}
                    onSelect={handleCheckboxChange}
                    onStar={(item) => handleStarClick(item._id, item.starred === true)}
                    onShare={(item) => handleSharePop(item._id)}
                    onDownload={(item) => handleAction(bucketNav[0], item?.content?.imageUrl?.[0]?.url, item?.title?.split(".").pop())}
                    onOpen={(item) => navigate(`/app/card-detail/${item._id}?card=file`)}
                  />
                ))}
              </div>
            ) : (
              <div className="files-empty-state"><h2>No files yet</h2><p>Files saved to this bucket will appear here.</p></div>
            )}
          </div>
        </div>
      )}
      {moveModal ? <MoveModal openMove={openMove} closeModal={closeMove} selectedItems={selectedItems} cardUpdate={cardsRefresh} buckets={buckets} /> : null}
    </>
  );
}
export default FilesPopup;
